/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState, useContext } from 'react';
import * as Api from '../../../api/Api';
import { useQuery } from 'react-query';
import * as KeyNames from '../../../api/KeyNames';
import { ErrorConnection } from '../../../Components/Error/Error';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import PermissionsGate from '../../../api/PermissionsGate';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { SCOPES } from '../../../config/permissions-map';
import './select_prmission.css'



export default function selectPermision({ listPermissionSelectDefault, setListPermission }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const [listPermissionTotal, setListPermissionTotal] = useState(null);

    const token = useGetToken();

    const setPermissionSelected = (isChecked, permission) => {
        if (!isChecked) {
            setListPermission(listPermissionSelectDefault.filter(element => element.id !== permission.id));
        }
        else {
            setListPermission(listPermissionSelectDefault.concat(permission));
        }
    }

    //Llamada al servicio de getPermissionList
    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta, 'ListaPermissions'],
        async () => await Api.getPermissionList({ token: token }),
        {
            enabled: true
        });

    useEffect(() => {
        if (data) {
            if (data.success) {
                setListPermissionTotal(data.data);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);

    function isPermissionInListPermision(permission) {
        const containsPermission = listPermissionSelectDefault.find(element => element.id === permission.id);
        return Boolean(containsPermission);
    }


    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <PermissionsGate RenderError={() => <></>} scopes={[SCOPES.GESTION_USUARIOS]} >
            {listPermissionTotal && <div className='row scroleable'>
                {
                    listPermissionTotal.map(item => (
                        <div className='col-12 col-sm-6' key={item.id}>
                            <div className="form-check form-check-custom form-check-solid form-check-sm mb-5">
                                <input className="form-check-input" type="checkbox" defaultChecked={isPermissionInListPermision(item)}
                                    onChange={(e) => {
                                        setPermissionSelected(e.target.checked, item);
                                    }}
                                    value={item.id}
                                    name={item.label} />
                                <label className="form-check-label" forhtml="flexCheckDefault">
                                    {item.label}
                                </label>
                            </div>

                        </div>
                    ))
                }
            </div>}
        </PermissionsGate >
    )
}
